import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import {HttpParams} from '@angular/common/http';
import { ToastsManager } from 'ng6-toastr';
import {Router} from '@angular/router';
import * as echarts from 'echarts';
import {RequestsService} from '../services/requests.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/** or */
import { graphic, registerMap } from 'echarts';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: []
})
export class DashboardComponent implements OnInit {

  constructor(private requestsService: RequestsService,private router: Router,public toastr: ToastsManager, vcr:ViewContainerRef, private http: HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);

    if (!window.localStorage.getItem(btoa('access_token')) || window.localStorage.getItem(btoa('access_token'))=='null' || window.localStorage.getItem(btoa('access_token'))==null) {
      this.router.navigate(['./login']);
    }
 }
///// REVENUE CHART //////
reveueDays=[];
reveueToday:any;
reveueTotals=[];
reveueOption:any;
///// Sale CHART //////
 saleDays=[];
 saleToday:any;
 saleTotals=[];
 saleOption:any;
///// Customer CHART //////
customerDays=[];
customerToday:any;
customerTotals=[];
customerOption:any;
///// Gross Profit CHART //////
grossprofitDays=[];
grossprofitTotals=[];
grossprofitToday:any;
grossprofitOption:any;
///// Discount CHART //////
discountDays=[];
discountTotals=[];
discountToday:any;
discountOption:any;

///// Discount Percent CHART //////
discountPercentDays=[];
discountPercentTotals=[];
discountPercentToday:any;
discountPercentOption:any;

///// Basket Value CHART //////
basketValueDays=[];
basketValueTotals=[];
basketValueToday:any;
basketValueOption:any;

///// Basket Size CHART //////
basketSizeDays=[];
basketSizeTotals=[];
basketSizeToday:any;
basketSizeOption:any;

currency:any;
testResult:any;
genral_settings:any;

 ngOnInit() {
   ///// Permissions ////////
  this.requestsService.CheckPermission(2);

    // this.testApi();
  this.genral_settings = JSON.parse(decodeURIComponent(escape(atob(window.localStorage.getItem(btoa('general_settings'))))));
  this.currency = JSON.parse(this.genral_settings.default_currency).value;

  this.getSaleCount('day');
  this.getRevenue('day');
  this.getCustomerCount('day');
  this.getGrossProfit('day');
  this.getDiscount('day');
  this.getDiscountPercent('day');
  this.getBasketValue('day');
  this.getBasketSize('day');
}
    // testApi() {
    //     const reqHeader = new HttpHeaders();
    //     reqHeader.append('Content-Type', 'application/json');
    //
    //     let URI = 'https://reqres.in/api/users';
    //     this.http.get(URI, { headers: reqHeader }).subscribe((response: Response)=>{
    //         this.testResult = response['data'];
    //         console.log(response);
    //
    //     });
    // }
getDay(){
  this.getSaleCount('day');
  this.getRevenue('day');
  this.getCustomerCount('day');
  this.getGrossProfit('day');
  this.getDiscount('day');
  this.getDiscountPercent('day');
  this.getBasketValue('day');
  this.getBasketSize('day');
}
getWeekly(){
  this.getSaleCount('week');
  this.getRevenue('week');
  this.getCustomerCount('week');
  this.getGrossProfit('week');
  this.getDiscount('week');
  this.getDiscountPercent('week');
  this.getBasketValue('week');
  this.getBasketSize('week');
}
getMonthly(){
  this.getSaleCount('month');
  this.getRevenue('month');
  this.getCustomerCount('month');
  this.getGrossProfit('month');
  this.getDiscount('month');
  this.getDiscountPercent('month');
  this.getBasketValue('month');
  this.getBasketSize('month');
}
/////////////////// REVENUE CHART //////////////////////
getRevenue(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getRevenue', body).subscribe(
    (response: Response) => {

      this.reveueDays = response['data'].days;
      this.reveueTotals = response['data'].totals;
      this.reveueToday = response['data'].totals[6];
          this.reveueOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.reveueDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }

          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.reveueTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)'

          }]
          }

    }
  );
}

/////////////////////////////// Sale Count Chart ////////////////////////////////////
getSaleCount(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getSaleCount', body).subscribe(
    (response: Response) => {

      this.saleDays = response['data'].days;
      this.saleTotals = response['data'].totals;
      this.saleToday = response['data'].totals[6];

          this.saleOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.saleDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.saleTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}

/////////////////////////////// Customer Count Chart ////////////////////////////////////
getCustomerCount(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getCustomerCount', body).subscribe(
    (response: Response) => {

      this.customerDays = response['data'].days;
      this.customerTotals = response['data'].totals;
      this.customerToday = response['data'].totals[6];

          this.customerOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.customerDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.customerTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}
/////////////////////////////// Gross Profit Chart ////////////////////////////////////
getGrossProfit(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getGrossProfit', body).subscribe(
    (response: Response) => {

      this.grossprofitDays = response['data'].days;
      this.grossprofitTotals = response['data'].totals;
      this.grossprofitToday = response['data'].totals[6];

          this.grossprofitOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.grossprofitDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.grossprofitTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}
/////////////////////////////// Discount Chart ////////////////////////////////////
getDiscount(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getDiscount', body).subscribe(
    (response: Response) => {

      this.discountDays = response['data'].days;
      this.discountTotals = response['data'].totals;
      this.discountToday = response['data'].totals[6];
          this.discountOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.discountDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.discountTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}
/////////////////////////////// Discount Percent Chart ////////////////////////////////////
getDiscountPercent(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getDiscountPercent', body).subscribe(
    (response: Response) => {

      this.discountPercentDays = response['data'].days;
      this.discountPercentTotals = response['data'].totals;
      this.discountPercentToday = response['data'].totals[6];

          this.discountPercentOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.discountPercentDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.discountPercentTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}
/////////////////////////////// BasketValue Chart ////////////////////////////////////
getBasketValue(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getBasketValue', body).subscribe(
    (response: Response) => {

      this.basketValueDays = response['data'].days;
      this.basketValueTotals = response['data'].totals;
      this.basketValueToday = response['data'].totals[6];

          this.basketValueOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.basketValueDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.basketValueTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}

/////////////////////////////// BasketSize Chart ////////////////////////////////////
getBasketSize(type) {
  let body = new HttpParams()
  .set('type',type);
  this.requestsService.postRequest('pos/data/getBasketSize', body).subscribe(
    (response: Response) => {

      this.basketSizeDays = response['data'].days;
      this.basketSizeTotals = response['data'].totals;
      this.basketSizeToday = response['data'].totals[6];

          this.basketSizeOption = {
            tooltip: {
              show: true,
              trigger: 'item',
              showContent: true,
            },
            grid: {
              top:10
            },
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.basketSizeDays,
            axisLabel: {
              rotate: 60,
              fontSize: 9
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              inside: true,
              color: '#cccc',
              fontSize: 9
            }

          },
          series: [{
            data: this.basketSizeTotals,
            type: 'line',
            areaStyle: {origin: 'auto'},
            color: '#99E3F9',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            hoverAnimation: true,
            legendHoverLink: true,
            cursor: 'pointer',
            emphasis:{
              label: {
                show: true
              }
            }

          }]
          }

    }
  );
}
}
